import React from 'react';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { ViewTypes } from 'src/constants/calendar';

import { Button, ViewTypeSwitcher } from './components';

interface HeaderProps {
  label: string;
  selectedViewType: ViewTypes;
  onChangeViewType: (value: ViewTypes) => void;
  onClickBackward: () => void;
  onClickForward: () => void;
}

export function Header({
  label,
  selectedViewType,
  onChangeViewType,
  onClickBackward,
  onClickForward,
}: HeaderProps) {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'flex-end',
      paddingBottom: '14px',
      borderBottom: '1px solid #F3F3F3',
      margin: '35px 32px 0px',
    }}>
      <Box>
        <Typography sx={{
          color: '#1F1F1F',
          fontWeight: '600',
          fontSize: '36px',
          lineHeight: 1,
        }}>
          {label}
        </Typography>
      </Box>
      <Box sx={{
        marginLeft: '14px',
      }}>
        <Button
          Icon={ChevronLeft}
          onClick={onClickBackward}
          sx={{marginRight: '4px'}}
        />
        <Button
          Icon={ChevronRight}
          onClick={onClickForward}
        />
      </Box>
      {/*@todo until better time*/}
      {/*<ViewTypeSwitcher*/}
      {/*  selected={selectedViewType}*/}
      {/*  onChange={onChangeViewType}*/}
      {/*/>*/}
    </Box>
  );
}
